import HOC from '../HOC';
import {techcrunch} from '../utility';

let Techcrunch = () => {return null;}

export default HOC(Techcrunch, techcrunch);



// WEBPACK FOOTER //
// ./src/components/News/Techcrunch.js